import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { title } from '@core/utils/filter';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useExtensaoList() {
  // Use toast
  const toast = useToast();

  const refUserListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'nome_tabela', label: 'Nome', sortable: true },
    { key: 'tabela_extensao', label: 'Tabela Pai', sortable: true },
    { key: 'created_at', label: 'Criado em' },
    { key: 'actions', label: 'Ações' },
  ];
  const perPage = ref(10);
  const totalUsers = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [5, 10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const roleFilter = ref(null);
  const planFilter = ref(null);
  const statusFilter = ref(null);
  const overlay = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    };
  });

  const refetchData = () => {
    refUserListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData();
  });
  const fetchExtensaos = (ctx, callback) => {
    overlay.value = true;
    store
      .dispatch('app-extensao/fetchExtensaos', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      })
      .then((response) => {
        const { data, total } = response.data;
        overlay.value = false;
        callback(data);
        totalUsers.value = total;
      })
      .catch(() => {
        overlay.value = false;
        callback([]);
        totalUsers.value = 0;
      });
  };
  const create = async (body) => {
    overlay.value = true;
    try {
      await store.dispatch('app-extensao/addExtensao', body);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Extensão criada com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro ao criar extensão',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    } finally {
      overlay.value = false;
    }
  };
  const Updated = async (formData) => {
    overlay.value = true;
    try {
      await store.dispatch('app-extensao/putExtensao', formData);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Extensão alterada com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro ao atualizar Extensão',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    } finally {
      overlay.value = false;
    }
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = (role) => {
    if (role === 'subscriber') return 'primary';
    if (role === 'author') return 'warning';
    if (role === 'maintainer') return 'success';
    if (role === 'editor') return 'info';
    if (role === 'admin') return 'danger';
    return 'primary';
  };

  const resolveUserRoleIcon = (role) => {
    if (role === 'subscriber') return 'UserIcon';
    if (role === 'author') return 'SettingsIcon';
    if (role === 'maintainer') return 'DatabaseIcon';
    if (role === 'editor') return 'Edit2Icon';
    if (role === 'admin') return 'ServerIcon';
    return 'UserIcon';
  };

  return {
    fetchExtensaos,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    overlay,
    create,
    Updated,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  };
}
